export default __webpack_public_path__ + "static/red-video-play-594767264b59b267fcf4308f74dc8d75.svg";